//#region Components
import CustomButton from "components/CustomButton/CustomButton";
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";
//#endregion

const DialogConfirmExitWithoutSaving = ({
    dialogShow,
    closeUpdateActivityDialog
}) => {
    return (
        <DialogAlertAction
            show={dialogShow.value}
            toggleShow={dialogShow.toggle}
            width="700px"
            widthContent="100%"
            variant="secondary"
            title="¿Deseas salir sin guardar los cambios?"
            content="Recuerda que si no guardas los cambios, estos se perderán y deberás registrarlos nuevamente.">
            <CustomButton 
                variant="secondary" 
                text="No, cancelar"
                width="120px"
                onClick={() => dialogShow.toggle(false)}/>
            <CustomButton 
                text="Sí, salir"
                width="120px"
                onClick={closeUpdateActivityDialog}/>
        </DialogAlertAction>
    );
}

export default DialogConfirmExitWithoutSaving;